import { ErrorMessage, Form, Formik } from "formik"
import clsx from "clsx"
import * as Yup from "yup"
import React from "react"
import { changeAccountPassword } from "../../../store/entities/Auth/Auth.actions"
import { selectProfileLoading } from "../../../store/selectors/Profile"
import { useDispatch, useSelector } from "react-redux"
import { FormHelperText } from "@material-ui/core"
import TextBox from "../../Common/Textbox/small"
import Button from "../../Common/Buttons/small"

const UserPasswordForm = ({}) => {
  const dispatch = useDispatch()

  const loading = useSelector(selectProfileLoading)

  const passwordSchema = Yup.object().shape({
    oldPassword: Yup.string()
      .min(8, "The password must have 8 character at least!")
      .max(50, "The password must be no more than 8 characters long!")
      .required("Field is required"),
    newPassword: Yup.string()
      .min(8, "The password must have 8 character at least!")
      .max(50, "The password must be no more than 8 characters long!")
      .required("Field is required")
      //TODO: oldPassword must actually be validated/compared to DB
      .notOneOf(
        [Yup.ref("oldPassword"), null],
        "Your new password must be different than your current password"
      ),
  })

  return (
    <Formik
      initialValues={{ oldPassword: "", newPassword: "" }}
      validationSchema={passwordSchema}
      onSubmit={(values, actions) => {
        dispatch(changeAccountPassword({ ...values }))
        actions.resetForm({ values: { oldPassword: "", newPassword: "" } })
      }}
    >
      {(props) => {
        const { handleSubmit, handleChange, errors, values } = props
        return (
          <Form className={clsx("flexColumn", "userInfoForm")}>
            <div className={"flexColumn"}>
              <label className={clsx("flexColumn", "inputContainer")}>
                <TextBox
                  placeholder=""
                  error={errors.oldPassword}
                  value={values.oldPassword}
                  type={"password"}
                  handleChange={handleChange}
                  tName={"oldPassword"}
                  label={"Old password"}
                  additionClass={"EMPHASIS_LARGE smallInput"}
                  htmlFor="outlined-basic-oldPassword"
                />
                {errors.oldPassword && (
                  <FormHelperText error={true}>
                    {errors.oldPassword}
                  </FormHelperText>
                )}
              </label>
              <label className={clsx("flexColumn", "inputContainer")}>
                <TextBox
                  placeholder=""
                  error={errors.newPassword}
                  value={values.newPassword}
                  type={"password"}
                  handleChange={handleChange}
                  tName={"newPassword"}
                  label={"New password"}
                  additionClass={"EMPHASIS_LARGE smallInput"}
                  htmlFor="outlined-basic-newPassword"
                />

                {errors.newPassword && (
                  <FormHelperText error={true}>
                    {errors.newPassword}
                  </FormHelperText>
                )}
              </label>
            </div>
            <div className={"CENTER_FLEX"}>
              <div className={"END_FLEX"}>
                <Button
                  loading={loading}
                  additionClass={""}
                  text={"Change password"}
                />
              </div>
            </div>
          </Form>
        )
      }}
    </Formik>
  )
}

export default UserPasswordForm
